import * as React from "react";
import { useHighLevelCalloutQuery } from "../../../../hooks/useHighLevelCalloutQuery";
import { CrossSellCarouselModel } from "../../../../models/view/crossSellCarouselModel";
import { CrossSellModel } from "../../../../models/domain/crossSellModel";
import { CrossSellCarousel } from "../../../../components/crossSellCarousel";
import { CrossSell } from "../../../../components/crossSell";
import { CrossSellListType } from "../../../../definitions/enums";
import { pushToDataLayer } from "../../../../hooks/useCrossSellDataLayerPush";

const crossSellCarouselModel = new CrossSellCarouselModel(<div className="fs-3 ms-2 p-3">Works Well With</div>);

export const WorksWellWith = () => {
  const { bundleModel, worksWellWithCrossSells, error } = useHighLevelCalloutQuery();
 
  // Initialize an empty products array
  let products: Array<{
    title: string;
    sku: string;
    price: number;
    listType: CrossSellListType.WorksWellWith;
  }> = [];

  // If there are cross-sells, populate the products array
  if (worksWellWithCrossSells.length > 0) {
    products = worksWellWithCrossSells.map((crossSell) => ({
      title: crossSell.product.title,
      sku: crossSell.product.sku,
      price: crossSell.price.unitPrice,
      listType: CrossSellListType.WorksWellWith,
    }));

    // Push to dataLayer regardless of the bundleModel condition
    pushToDataLayer(products);
  }

  // If there is an error or no cross-sells, don't render anything
  if (error || worksWellWithCrossSells.length === 0) return <></>;

  // If there is a bundle, render the works well with carousel below the accordion
  if (bundleModel) {
    return <WorksWellWithCarousel crossSells={worksWellWithCrossSells} />;
  }

  // Otherwise, render the works well with carousel above the accordion (high-level callout)
  return <></>;
};

export const WorksWellWithCarousel = ({ crossSells }: { crossSells: CrossSellModel[] }) => {
  return (
    <CrossSellCarousel model={crossSellCarouselModel}>
      {crossSells.map((crossSell, index) => (
        <CrossSell key={index} listType={CrossSellListType.WorksWellWith} model={crossSell} index={index} />
      ))}
    </CrossSellCarousel>
  );
};
